export const Language = {
  FR: 'fr',
  GB: 'en'
};
  